module.exports = __webpack_public_path__ + "media/metronic/_theme/media/envato/screen1-e9e2ef549ef859b37a87797a5c942469.jpg";